import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { Provider } from "react-redux";
import { store, persistor } from "./redux/store/store";
import { PersistGate } from "redux-persist/integration/react";
import { HelmetProvider } from "react-helmet-async";
import { LoadingProvider } from "./utilis/LoadingContext";
import ScrollToTop from "./utilis/Scroll";
import "react-toastify/dist/ReactToastify.css"; // ← add this if missing
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Router>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <LoadingProvider>
          <HelmetProvider>
            <ScrollToTop />
            <ToastContainer
              position="top-right"
              autoClose={3000}
              style={{ zIndex: 99999 }} // ← add this
            />
            <App />
          </HelmetProvider>
        </LoadingProvider>
      </PersistGate>
    </Provider>
  </Router>,
);
reportWebVitals();
